import { render, staticRenderFns } from "./LoggedInSidebar.vue?vue&type=template&id=49cf22aa&scoped=true&"
import script from "./LoggedInSidebar.vue?vue&type=script&lang=js&"
export * from "./LoggedInSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LoggedInSidebar.vue?vue&type=style&index=0&id=49cf22aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf22aa",
  null
  
)

export default component.exports